import React, { useEffect, useState } from "react"
import { createContainer } from "unstated-next"
import * as voicifyApi from '../api';
import User from "../models/user/User";
import { v4 as uuidv4 } from 'uuid';
import ApplicationMemberModel from "../models/applications/api/ApplicationMemberModel";
import OrganizationMemberModel from "../models/organizations/api/OrganizationMemberModel";


function useReviewUserContainer() {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [member, setMember] = useState({} as OrganizationMemberModel);
    const loadApp = async (appId: string) => {        
        setLoading(true);
        const result = await voicifyApi.getApplicationMembers(appId);
        if (result.resultType !== "Ok") {
            setError(result.errors[0]);
            setLoading(false);
            return;            
        } 
        else {
            var reviewUser = result.data.find(m => m.organizationMember.email.endsWith("@review-user.com"));
            if (reviewUser?.organizationMember?.email?.length) {
                setMember(reviewUser.organizationMember);
            }
            setLoading(false);

        }

    }

    const createNewReviewUser = async (appId: string, password: string) => {
        setLoading(true);
        const result = await voicifyApi.refreshReviewUser({ applicationId: appId, password: password });
        if (result.resultType !== "Ok") {
            setError(result.errors[0]);
            setLoading(false);
            return;
        } 
        setLoading(false);
    }

    return {
        error,
        setError,
        loading,
        setLoading,
        member,
        loadApp,
        createNewReviewUser
    }
}

const ReviewUserContainer = createContainer(useReviewUserContainer);
export default ReviewUserContainer;
